<template>
    <div>
        <!-- <div v-if="Names == ''">
            <Mainlayout></Mainlayout>
        </div>
        <div v-else>
            <MainlayoutLogin></MainlayoutLogin>
        </div> -->
        <Mainlayout></Mainlayout>
     
        <CCol sm="12" class="bg-FAFAFA">
            
    
            <CCol sm="8" style="width: 90%;background-size: cover; margin: auto;color: #fff">
                <br /> <br /> <br /> <br /> <br />
                <CCard class="bg-white b-20 m-" style="border:none;">
                <CRow class="m-1">
                    <CCol sm="12">
                        <h3 class="custom-40px-500 text-center mt-3">Frequently asked questions</h3>
                        <p class="custom-18px-400 text-center m-2 font-general-sans">If you have questions that are not listed here, send them to us via email.</p>
                    </CCol>
                    <CCol sm="12">
                        <div style="text-align: left;" class="{ activeclass: isActive }">
                                    <ToggleCard title="1. What is Interviewrr.ai?">
                                        Interviewrr.ai is a state-of-the-art AI-powered platform designed to help job seekers improve their interview skills through automated question generation and video interviews. Users receive feedback from industry experts and AI algorithms to refine their skills and resumes.

                                    </ToggleCard>
    
                                    <ToggleCard title="2. How does the video interview process work?">
                                        Users record their answers to automatically generated questions via their device and submit the video on our platform. Our advanced AI analyzes the video and voice to identify user characteristics and how closely their answers align with those suggested by experts. It categorizes responses into individual user profiles, accessible only by the user or potential employers. In addition to AI analysis, we partner with other companies to review each candidate and offer feedback through our system. Following submission, they receive expert feedback and tailored advice to help enhance their interview performance.
</ToggleCard>
    
                                    <ToggleCard title="3. Is there a cost to use Interviewrr.ai?">
                                        Interviewrr.ai offers two free practice sessions for all users. If you wish to continue using the platform beyond these sessions, a minimal fee will apply for additional usage.
</ToggleCard>
    
                                    <ToggleCard title="4. Can companies view my video interviews?">
                                        Yes, with your consent, companies searching for new employees can view your video interviews. You will be asked whether you wish to make your videos accessible to potential employers after submitting your last video.</ToggleCard>
    
                                    <ToggleCard title="5. How can companies access candidate videos?">
                                        Companies can access videos of candidates based on the specific job categories they are interested in. Access is dependent on the type of package they have purchased, which determines how many and which videos they can view. 

</ToggleCard>
    
                                    <ToggleCard title="6. How does Interviewrr.ai ensure fairness and accuracy in feedback?">
                                        Our AI algorithms are designed to objectively assess candidates' skills and qualifications, complemented by insights from industry experts. This dual approach helps eliminate bias and improve the accuracy of the feedback provided.
</ToggleCard>
                                    
                                        <ToggleCard title="7. What can I do if I need more than two practice sessions?">
                                            If you need additional practice beyond the free sessions, you can easily continue using Interviewrr.ai by paying a minimal fee for each subsequent session. This allows you to further hone your skills at a reasonable cost. The price can be viewed at plan page.
                                        these preferences on your settings page, ensuring a comfortable and secure interaction.</ToggleCard>
                                    
                                       
                                </div>
                    </CCol>
                </CRow>
            </CCard>
    
            </CCol>
    
        </CCol>

        <CCol sm="12" class="p-1" style="background-size: cover;color: #fff">
            <br /> <br /> <br />
            <CCol sm="12" lg="12">
                <div class="text-center p-2">
                    <CCol sm="12" style="width: 90%;margin: auto;">
                        <div class="text-center" style="background-size: cover;border-radius: 20px;" :style="{ backgroundImage: `url(${backgroundUrNoArrow})` }">
                            <br />
                            <br /> <br /> <br />
                            <h1 class="custom-header-join text-white poppin-font text-48px mt-5">Subscribe Now for Free</h1>
                            <br />
                            <label class="custom-header-join-sub text-white">
                                Sign up now for free and take the first step toward landing your dream job!
                                                                </label>
                            <br />
                            <br /> <br /> <br />
                            <CButton class="button-Explore"><span class="ml-2 mr-2">Inquire</span></CButton>
                            <br />
                            <br /> <br /> <br />
                            <br />
                        </div>
                    </CCol>
                </div>
                <br /><br /><br />
            </CCol>
    
    
        </CCol>
    
        <Footerlayout></Footerlayout>
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bg.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";

import Mainlayout from "../containers/AllHeader.vue";
import MainlayoutLogin from "../containers/LoginHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import backgroundUrNoArrow from "../assets/img/bgline.png";
import ToggleCard from '../components/Toggle.vue';

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        MainlayoutLogin,
        Footerlayout,
        ToggleCard
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap,
            backgroundUrNoArrow,
            Names: "",

        };
    },
    created() {
        AOS.init();
    },
    mounted() {
        // const isAuth = this.UserAuth();
        //     if (isAuth) {
        //     this.GetInfoUser();
        // } else {
        //     this.loading = false; // If not authenticated, immediately set loading to false
        // }
},
methods: {
    async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, { withCredentials: true });
                if (response.status === 200 && response.data) {
                    this.user = response.data;
                    this.Names = this.user.name;
                } else {
                    this.$router.push("Faq");
                    console.error("User info retrieval failed:", response.data.detail);
                }
            } catch (error) {
                this.$router.push("Faq");
                console.error("Error fetching user info:", error);
            }
        },
}

};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}
</style>